import {
  HStack,
  Stack,
  Text,
  Tag,
} from "@chakra-ui/react";

interface HeaderProps {
  title: string;
  starthour: string;
  endHour: string;
  levels?: {
    id: string;
    level: {
      name: string;
      color: string;
      variant: string;
    };
  }[]
}

export function Header({
  title,
  starthour,
  endHour,
  levels
}: HeaderProps) {
  return (
    <Stack
      alignItems="flex-start"
      spacing="auto"
      color="blue.900"
      borderTopRadius="5"
    >
      <HStack w="100%">
        <Text
          fontSize="sm"
          textAlign="left"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          flex="1"
        >
          <strong>{title}</strong>
        </Text>
      </HStack>
      <Stack
        spacing="1"
        alignItems="left"
        direction={['column', 'row']}
      >
        <HStack spacing="1" overflow="hidden" flexWrap="nowrap">
          <Text
            fontSize={["small"]}
            color="blue.800"
            flexShrink={0}
          >
            {starthour} - {endHour}
          </Text>
          {levels?.slice(0, 2).map(levelItem => (
            <Tag key={levelItem.id} size="sm" colorScheme="gray" flexShrink={0}>
              {levelItem.level.name}
            </Tag>
          ))}
          {levels && levels.length > 2 && (
            <Text fontSize="xs" color="gray.500" flexShrink={0}>...</Text>
          )}
        </HStack>
      </Stack>
    </Stack>
  )
}
